// 将对象的值赋给目标对象
export const valKeys = (obj, target) => {
  for (let key in obj) {
    obj[key] = target[key];
  }
};

// 克隆对象的值到目标对象
export const clonKeys = (target, source) => {
  for (let key in target) {
    if (source.hasOwnProperty(key)) {
      target[key] = source[key];
    }
  }
};

// 清空对象的所有属性值
export const clearKeys = (target) => {
  for (let key in target) {
    if (target[key] instanceof Array) {
      target[key] = [];
    } else {
      target[key] = undefined;
    }
  }
};

// 获取UUID
export const getUuid = () => {
  let d = new Date().getTime();
  const uuid = "xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};

// 格式化日期
export const formatDate = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  if (!date) return '';
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');
  
  return format
    .replace('YYYY', year)
    .replace('MM', month)
    .replace('DD', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
};

// 深拷贝
export const deepClone = (obj) => {
  if (obj === null || typeof obj !== 'object') return obj;
  if (obj instanceof Date) return new Date(obj.getTime());
  if (obj instanceof Array) return obj.map(item => deepClone(item));
  if (typeof obj === 'object') {
    const clonedObj = {};
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        clonedObj[key] = deepClone(obj[key]);
      }
    }
    return clonedObj;
  }
};

// 千分位
export function format_with_substring(number) {
  var arr = (number + '').split('.');
  var int = arr[0] + '';
  var fraction = arr[1] || '';
  var f = int.length % 3;
  var r = int.substring(0, f);
  for (var i = 0; i < Math.floor(int.length / 3); i++) {
    r += ',' + int.substring(f + i * 3, f + (i + 1) * 3)
  }
  if (f === 0) { r = r.substring(1); }
  return r + (!!fraction ? "." + fraction : '');
}

export const formatPrice = (params) => {
  if (params === null || params === undefined || params === '') return '0.00';
  const num = Number(params);
  if (isNaN(num)) return '0.00';
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const generatePriceRangeText = (priceRangeList) => {
  const result = [];
  priceRangeList.sort((a, b) => Number(a.startQuantity) - Number(b.startQuantity));
  for (let i = 0; i < priceRangeList.length; i++) {
    const current = priceRangeList[i];
    const next = priceRangeList[i + 1];
    if (next) {
      result.push(`数量:${current.startQuantity}-${Number(next.startQuantity) - 1}  ${i18n.t('cart.wslang189')}:${current.price}  `);
    } else {
      result.push(`${i18n.t('cart.oneEight34')}:${current.startQuantity}  ${i18n.t('cart.wslang189')}:${current.price}`);
    }
  }
  return result.join('，');
};

export const formatPricingzh = (arr) => {
  return arr.map((item, index) => {
    const formattedPrice = `${item.price}`;
    let formattedQuantity;
    if (index === arr.length - 1) {
      formattedQuantity = `≥${item.startQuantity}`;
    } else {
      const nextStartQuantity = arr[index + 1].startQuantity - 1;
      formattedQuantity = `${item.startQuantity}-${nextStartQuantity}`;
    }
    return { price: formattedPrice, startQuantity: formattedQuantity };
  });
};

export const get1688Price = (priceRangeList, quantity) => {
  if (!priceRangeList || !priceRangeList.length) return undefined
  const matchedRange = [...priceRangeList].reverse().find(range => Number(quantity) >= Number(range.startQuantity))
  return matchedRange?.price || undefined
};
